import { Box, Typography } from '@mui/material';

import { CreateNodeSaleForm } from 'src/components/NodeSaleForm/CreateNodeSaleForm';
import { DeploymentProvider } from 'src/provider/DeploymentProvider';
import { ThemeCustomizationProvider } from 'src/provider/ThemeCustomizationProvider';

const CreateProject = () => {
  return (
    <Box width={'100%'} height={'100%'} display={'flex'} justifyContent={'center'} minHeight={'100dvh'}>
      <Box
        sx={{
          marginTop: '40px',
          maxWidth: '728px',
          width: '100%',
        }}>
        <Typography
          textAlign={'center'}
          color={'white'}
          fontWeight={700}
          fontSize={'32px'}
          variant='h5'
          paddingBottom={3}>
          CREATE SALE PROGRAM
        </Typography>
        <DeploymentProvider initialHasDeployed={false}>
          <ThemeCustomizationProvider>
            <CreateNodeSaleForm />
          </ThemeCustomizationProvider>
        </DeploymentProvider>
      </Box>
    </Box>
  );
};

export default CreateProject;
